import { render, staticRenderFns } from "./ExpenseSheets.vue?vue&type=template&id=6faa35da&scoped=true&"
import script from "./ExpenseSheets.vue?vue&type=script&lang=js&"
export * from "./ExpenseSheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa35da",
  null
  
)

export default component.exports